module.exports = __webpack_public_path__ + "img/empty-insurance.22cfe8e4.png";